<template>
  <div>
    <div class="flex preference-description">
      <div class="box grow">
        <h5>IDP Settings</h5>
        <p>Configure your IDP interface settings here.</p>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="preference-settings" v-if="idpSettingReqStatus==='saved'">
      <div class="box grow flex column">
        <div class="box grow flex">
          <div class="box title">IDP Server</div>
          <div class="box grow">
            <div class="box grow flex form-input">
              <div class="box title">Entity Id</div>
              <div class="box grow">
                <el-input v-model="copyIDPSettings.entityId"></el-input>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="box grow flex form-input">
              <div class="box title">Single Sign-On Url</div>
              <div class="box grow">
                <el-input v-model="copyIDPSettings.ssoUrl"></el-input>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="box grow flex form-input">
              <div class="box title">Single Sign-On Binding</div>
              <div class="box grow">
                <el-input v-model="copyIDPSettings.ssoBinding" disabled></el-input>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="box grow flex form-input">
              <div class="box title">Certificate</div>
              <div class="box grow">
                <el-input 
                  type="textarea"
                  :autosize="{ minRows: 10, maxRows: 12 }"
                  v-model="copyIDPSettings.certificate">
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="box grow flex float-right footer">
      <el-button type="text" class="icon-text-button" @click="cancelIDPSettings()">
        <i class="material-icons c-icon">cancel</i>
        <span>Reset</span>
      </el-button>
      <el-button type="text" class="icon-text-button" @click="udpateIDPSettings()">
        <i class="material-icons c-icon">save</i>
        <span>Save</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  IDP_SETTING_REQUEST,
  IDP_SETTING_CREATE_REQUEST,
  IDP_SETTING_UPDATE_REQUEST
} from "@/store/modules/idp/idp-setting.type";

export default {
  name: "IdpSetting",
  data() {
    return {
      copyIDPSettings: {
        entityId: undefined,
        ssoUrl: undefined,
        ssoBinding: undefined,
        certificate: undefined
      }
    };
  },
  methods: {
    getIDPSettings() {
      this.$store.dispatch(IDP_SETTING_REQUEST).then(preferences => {
        this.copyIDPSettings = _.cloneDeep(this.idpSettings);
      });
    },
    printSuccessMessage() {
      this.$message({
        type: "success",
        message: "IDP settings were successfully saved."
      });
    },
    printErrorMessage() {
      this.$message({
        type: "error",
        message: "IDP settings failed to save."
      });
    },
    cancelIDPSettings() {
      this.copyIDPSettings = _.cloneDeep(this.idpSettings);
    },
    udpateIDPSettings() {
      let {entityId, ssoUrl, ssoBinding, certificate} = this.copyIDPSettings;
      if (entityId && ssoUrl && ssoBinding && certificate) {
        this.$store
        .dispatch(IDP_SETTING_CREATE_REQUEST, this.copyIDPSettings)
        .then(
          preferences => {
            this.printSuccessMessage();
          },
          errMsg => {
            this.printErrorMessage();
          }
        );
      }
      else {
        this.printErrorMessage();
      }
    }
  },
  created() {
    this.getIDPSettings();
  },
  computed: {
    ...mapGetters([
      "idpSettings",
      "idpSettingReqStatus"
    ])
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "assets/styles/_variables.css";

.preference-description {
  > .box:first-of-type {
    margin-right: 50px;
  }
}

.preference-settings {
  overflow: scroll;
  height: calc(100vh-280px);

  .title {
    min-width: 200px;
  }
}

.email {
  font-size: 6em;
}

.form-input {
  line-height: 40px;
}

>>> .el-select > .el-input {
  min-width: 250px;
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
  }
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0.5em 0px;
}

.footer {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/IdpSetting.vue